import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=3cd9cac0&"
import script from "./contacts.vue?vue&type=script&lang=ts&setup=true&"
export * from "./contacts.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd9cac0')) {
      api.createRecord('3cd9cac0', component.options)
    } else {
      api.reload('3cd9cac0', component.options)
    }
    module.hot.accept("./contacts.vue?vue&type=template&id=3cd9cac0&", function () {
      api.rerender('3cd9cac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/contacts.vue"
export default component.exports